<mat-form-field>
  <mat-select
    [disableOptionCentering]="true"
    [panelClass]="panelClass"
    multiple
    #select
    [formControl]="control"
    (openedChange)="onSelectOpenedChange()"
  >
    <div class="search-row like-option">
      <input [placeholder]="'MAIN.SEARCH' | translate" [(ngModel)]="searchValue" (keyup)="onSearchKeyUp()" />
    </div>
    <div class="select-all like-option">
      <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{ standalone: true }" (change)="toggleAllSelection()">
        {{ (allSelected ? 'MAIN.UNSELECT_ALL' : 'MAIN.SELECT_ALL') | translate }}
      </mat-checkbox>
    </div>
    @for (item of items; track item.id) {
    <mat-option
      [class.hidden]="hiddenItems[item.id]"
      [class.always-at-top]="item.alwaysAtTop"
      (click)="onOptionClick(item[valueField])"
      [value]="item[valueField]"
    >
      {{ item[labelField] }}
    </mat-option>
    } @if (isNothingFound) {
    <div class="nothing-found like-option">{{ 'MAIN.NOTHING_FOUND' | translate }}</div>
    }
  </mat-select>
</mat-form-field>
